// extracted by mini-css-extract-plugin
module.exports = {"preview":"idt-colorattributedropdownitem_preview__2hfdg"};